import { createAction } from 'redux-act';
import { paramsForServer } from 'feathers-hooks-common';
import { TopicService, UserService, SchoolClassService } from 'services';

import { KEYS } from 'utils/constants';
import { setLoading } from '../loading/actions';
import { getSearchForUsersReduxKey } from './utils';

export const updateState = createAction('updateState');

export const updateGlobalItem = createAction('updateGlobalItem');
export const addToGlobalItem = createAction('addToGlobalItem');

export const setGlobalTopic = (_id) => {
  return async (dispatch) => {
    const topic = await TopicService.get(_id);
    dispatch(
      addToGlobalItem({
        key: 'topics',
        data: topic,
      })
    );
  };
};

export const searchForUsers = (payload, cb = () => null) => {
  return async (dispatch) => {
    const { schoolClassId, shouldHideSuspendedUsers, organizationId, search, userType } = payload;

    const query = {
      search,
      userType,
      action: 'search-for-users',
    };

    if (schoolClassId) query.schoolClassId = schoolClassId;

    if (shouldHideSuspendedUsers) query.shouldHideSuspendedUsers = true;

    if (organizationId) query.organizationId = organizationId;

    const { data } = await UserService.find(paramsForServer({ query }));

    cb();
    dispatch(
      updateGlobalItem({
        key: getSearchForUsersReduxKey({ userType }),
        data,
      })
    );
  };
};

export const clearSearchForUsers = ({ userType }) => {
  return async (dispatch) => {
    dispatch(
      updateGlobalItem({
        key: getSearchForUsersReduxKey({ userType }),
        data: [],
      })
    );
  };
};

export const getUser = (userId, populate) => {
  return async (dispatch) => {
    dispatch(
      setLoading({
        key: KEYS.getUser,
        value: true,
      })
    );

    try {
      const userData = await UserService.get(
        userId,
        paramsForServer({
          populate: populate || 'DEFAULT',
        })
      );

      const { data: userSchoolData } = await SchoolClassService.find(
        paramsForServer({
          query: {
            studentIds: userData._id,
            $select: ['primaryTeacherId', 'organizationId', 'title'],
          },
        })
      );

      const data = {
        ...userData,
        schoolClass: userSchoolData[0],
      };

      dispatch(
        updateGlobalItem({
          key: 'user',
          data,
        })
      );

      return data;
    } catch (err) {
      alert(`Failed to retrieve user: ${err.message}`);
    } finally {
      dispatch(
        setLoading({
          key: KEYS.getUser,
          value: false,
        })
      );
    }
  };
};
